import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import FooterTest from "./FooterTest";

const Layout = ({ children }) => {
  const location = useLocation();

  // Define routes where Header and Footer should not appear
  const noLayoutRoutes = ["/login", "/forgot-password", "/force-password-change", "/password-change", "/dashboard"];

  // Check if the current path is in the noLayoutRoutes list
  const shouldRenderLayout = !noLayoutRoutes.includes(location.pathname);

  return (
    <>
      {shouldRenderLayout && <Header />}
      <main className="w-full">{children}</main>
      {shouldRenderLayout && <FooterTest />}
    </>
  );
};

export default Layout;
